import {
  ADMIN_EDIT_FAILURE,
  ADMIN_EDIT_REQUEST,
  ADMIN_EDIT_SUCCESS,
  ADMIN_VIEW_FAILURE,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_SUCCESS,
  AUTH_RESET_STATE,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  REDIRECT,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REQUEST_OTP_FAILURE,
  REQUEST_OTP_REQUEST,
  REQUEST_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
} from "./authType";

export const loginRequest = (credentials) => ({
  type: LOGIN_REQUEST,
  payload: credentials,
});

export const loginSuccess = (data) => {
  return {
    type: LOGIN_SUCCESS,
    payload: {
      user: data.user,
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      successMessage: "Login successful!",
    },
  };
};

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const registerRequest = (credentials) => ({
  type: REGISTER_REQUEST,
  payload: credentials,
});

export const registerSuccess = (user) => ({
  type: REGISTER_SUCCESS,
  payload: user,
});

export const registerFailure = (error) => ({
  type: REGISTER_FAILURE,
  payload: error,
});

export const requestOtpRequest = (email) => ({
  type: REQUEST_OTP_REQUEST,
  payload: email,
});

export const requestOtpSuccess = (otp) => ({
  type: REQUEST_OTP_SUCCESS,
  payload: otp,
});

export const requestOtpFailure = (error) => ({
  type: REQUEST_OTP_FAILURE,
  payload: error,
});

export const verifyOtpRequest = (credentials) => ({
  type: VERIFY_OTP_REQUEST,
  payload: credentials,
});

export const verifyOtpSuccess = (response) => ({
  type: VERIFY_OTP_SUCCESS,
  payload: response,
});

export const verifyOtpFailure = (error) => ({
  type: VERIFY_OTP_FAILURE,
  payload: error,
});

export const refreshTokenRequest = (credentials) => ({
  type: REFRESH_TOKEN_REQUEST,
  payload: credentials,
});

export const refreshTokenSuccess = (response) => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload: response,
});

export const refreshTokenFailure = (error) => ({
  type: REFRESH_TOKEN_FAILURE,
  payload: error,
});
export const resendOtpRequest = (email) => ({
  type: RESEND_OTP_REQUEST,
  payload: email,
});

export const resendOtpSuccess = (otp) => ({
  type: RESEND_OTP_SUCCESS,
  payload: otp,
});

export const resendOtpFailure = (error) => ({
  type: RESEND_OTP_FAILURE,
  payload: error,
});

export const updatePasswordRequest = (passwordData) => ({
  type: UPDATE_PASSWORD_REQUEST,
  payload: passwordData,
});

export const updatePasswordSuccess = (response) => ({
  type: UPDATE_PASSWORD_SUCCESS,
  payload: response,
});

export const updatePasswordFailure = (error) => ({
  type: UPDATE_PASSWORD_FAILURE,
  payload: error,
});

export const changePasswordRequest = (password) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload: password,
});

export const changePasswordSuccess = (payload) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: payload,
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error,
});

export const adminEditRequest = (data) => ({
  type: ADMIN_EDIT_REQUEST,
  payload: data,
});

export const adminEditSuccess = (response) => ({
  type: ADMIN_EDIT_SUCCESS,
  payload: response,
});

export const adminEditFailure = (error) => ({
  type: ADMIN_EDIT_FAILURE,
  payload: error,
});

export const adminViewRequest = (id) => ({
  type: ADMIN_VIEW_REQUEST,
  payload: id,
});

export const adminViewSuccess = (data) => ({
  type: ADMIN_VIEW_SUCCESS,
  payload: data,
});

export const adminViewFailure = (error) => ({
  type: ADMIN_VIEW_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT,
});

export const redirect = (payload) => ({
  type: REDIRECT,
  payload,
});

export const authResetState = () => ({
  type: AUTH_RESET_STATE,
});
